// app/router.options.ts
import type { RouterConfig } from "@nuxt/schema";

// https://router.vuejs.org/guide/advanced/scroll-behavior.html
export default <RouterConfig>{
   scrollBehavior(to, from, savedPosition) {
      const nuxtApp = useNuxtApp();

      // if (savedPosition) {
      //    return savedPosition;
      // } else {
      //    // Otherwise, always scroll to top on new route
      //    console.log("-------SCROLLTOP--------");
      //    return { left: 0, top: 0 };
      // }
      return new Promise((resolve) => {
         const { $lenis } = useNuxtApp();
         setTimeout(() => {
            $lenis?.scrollTo(0, { immediate: true, force: true });
            resolve({ left: 0, top: 0 });
         }, 350);
      });
   },
};
